<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="box_2 flex-row">
        <span class="text_1">面试时长：</span>
        <div class="duration-select">
          <div class="block_1 flex-row" @click="showDurationSelect">
            <span class="text_2">{{ selectedDuration }}</span>
            <img class="thumbnail_3" referrerpolicy="no-referrer" :class="{ 'rotate': showDurationOptions }"
              src="./assets/img/SketchPng32bb5ffc73b63ed9396c4ca5c88708cf949f1f38de2bf548b59a76f324c084d7.png" />
          </div>
          <!-- 下拉选项 -->
          <div v-show="showDurationOptions" class="duration-options">
            <div v-for="option in durationOptions" :key="option.value" class="duration-option"
              @click="selectDuration(option)">
              {{ option.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="group_6 flex-col">

      <div class="group_71 flex-row">
        <div v-show="isTooltipVisible_gerenzhongxin" class="text-wrapper_2 flex-col">
          <span class="text_4">个人中心</span>
        </div>
      </div>

      <div class="group_7 flex-row margin-top_1vw">
        <div v-show="isTooltipVisible" class="text-wrapper_2 flex-col">
          <span class="text_4">面试记录</span>
        </div>
      </div>

      <transition name="fade-move">
        <div class="cebianlan_guanbi flex-row" v-show="!cebianlanOpen">
          <img class="thumbnail_5" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
            @click="cebianlan()" />
        </div>
      </transition>

      <div class="group_8 flex-row">
        <button class="text-wrapper_3 flex-col" @click="gotointerview()"><button class="text_5">提交</button></button>
      </div>
      <transition name="slide-fade">
        <div class="section_1 flex-col" v-show="cebianlanOpen">
          <div class="image-wrapper_1 flex-col" @click="gotoshouye1()">
            <img class="thumbnail_2" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng2f8376ef072d8731ef0759ac314175f81349de65e0879cbabee91899d239e979.png" />
          </div>
          <div class="box_4 flex-col"></div>
          <div class="image-wrapper_2 flex-col" @mouseenter="showTooltip_gerenzhongxin"
            @mouseleave="hideTooltip_gerenzongxin" @click="gotogerenzhongxin()">
            <div class="image-wrapper_4 flex-col">
              <img class="thumbnail_4" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng01135b14fea1a6ed0f1d7a6a8f017e9925d08bd6a28672465f01adabe77a5515.png" />
            </div>
          </div>
          <div class="image-wrapper_3 flex-row" @mouseenter="showTooltip" @mouseleave="hideTooltip"
            @click="gotomianshilishi()">
            <!-- <img
              class="label_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng69ca8e0b3481a9a549219528012548530789e9bb7bb5e5cca1c0312f7bf7d5cf.png"
            /> -->
            <img class="label_2" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng8e6cd64a36098966424450b0dad4bd1cc789add12a6963e32d14afbe743b5648.png" />
          </div>
          <div class="box_5 flex-col"></div>
          <el-dropdown placement="right"
            style="background-color: transparent;width:4.5vw;height:7.5vh;position:absolute;top:29vh;z-index: 1;">
            <el-button style="background-color: transparent;border:none;width:100%;height:100%;">
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><button @click="logout">登出</button></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="text-wrapper_1 flex-col"><span class="text_3">登录</span></div>
          <img class="thumbnail_5" referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
            @click="cebianlan()" />
        </div>
      </transition>
      <el-upload class="group_3 flex-col el-tiaozheng" drag action:>
        <div class="group_4 flex-col"></div>
        <div class="text-group_3 flex-col">
          <span class="text_6">上传简历</span>
          <span class="text_7">点击或将简历拖拽至此处上传</span>
          <span class="text_8">支持pdf、word、jpg、png</span>
        </div>
      </el-upload>
      <el-upload class="group_5 flex-col" drag action:>
        <div class="section_2 flex-col"></div>
        <div class="text-group_4 flex-col">
          <span class="text_9">上传岗位JD</span>
          <span class="text_10">点击或将简历拖拽至此处上传</span>
          <span class="text_11">支持pdf、word、jpg、png</span>
        </div>
      </el-upload>
    </div>
  </div>

</template>
<script>
import Selector from '@/components/Selector/index.vue'
export default {
  components: {
    Selector
  },
  data() {
    return {
      isTooltipVisible: false,
      isTooltipVisible_gerenzhongxin: false,
      tooltipTimeout: null,
      cebianlanOpen: true,
      selectedDuration: '30分钟',
      showDurationOptions: false,
      durationOptions: [
        { label: '30分钟', value: 30 },
        { label: '1小时', value: 60 }
      ]
    };
  },
  methods: {

    cebianlan() {
      this.cebianlanOpen = !this.cebianlanOpen;
    },
    showTooltip() {
      this.tooltipTimeout = setTimeout(() => {
        this.isTooltipVisible = true;
      }, 500);
    },
    hideTooltip() {
      clearTimeout(this.tooltipTimeout);
      this.isTooltipVisible = false;
    },
    gotomianshilishi() {
      this.$router.push('/lanhu_mianshilishi');
    },
    gotogerenzhongxin() {
      this.$router.push('/lanhu_gerenzhongxin');
    },
    showTooltip_gerenzhongxin() {
      this.tooltipTimeout = setTimeout(() => {
        this.isTooltipVisible_gerenzhongxin = true;
      }, 500);
    },
    hideTooltip_gerenzongxin() {
      clearTimeout(this.tooltipTimeout);
      this.isTooltipVisible_gerenzhongxin = false;
    },
    gotoshouye1() {
      this.$router.push('/lanhu_shouye1');
    },
    showDurationSelect() {
      this.showDurationOptions = !this.showDurationOptions
    },
    selectDuration(option) {
      this.selectedDuration = option.label
      this.showDurationOptions = false
    },
    gotointerview() {
      this.$router.push('/interview')
    },
    logout() {
      this.$store.dispatch('user/logout')
    }
  }
}
</script>
<style scoped lang="css" src="./assets/index.response.css" />
